import React from 'react';
import styled from 'styled-components';
import { tertiaryGrey, white } from 'styles/Colors';
import { ReactComponent as InfoIcon } from 'components/icons/strikezoneInfo.svg';

export const StrikeZoneMissingWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const Badge = styled.span`
  background-color: #fe9800;
  font-size: 11px;
  line-height: 15.4px;
  color: ${white};
  padding: 0 4px;
  border-radius: 34px;
  font-weight: 700;
`;

export const Description = styled.div`
  color: ${tertiaryGrey};
  font-size: 15px;
  line-height: 21px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ModalContent = styled.div`
  padding: 24px 32px;
  font-size: 15px;
  line-height: 21px;
`;

export const Label = styled.div`
  font-weight: 700;
  width: 50%;
`;

export const LabelWrapper = styled.div`
  display: flex;
  font-size: 13px;
  line-height: 18.2px;
  margin-top: 16px;
`;

export const PlayerWrapper = styled.div`
  display: flex;
  font-size: 13px;
  line-height: 18.2px;
  margin-top: 8px;
`;

export const Name = styled.div`
  width: 50%;
`;

export const Id = styled.div`
  width: 50%;
`;

export const Info = styled.div`
  color: #a0a0a0;
  font-size: 13px;
  line-height: 18.2px;
  margin-top: 16px;
`;

export const StyledInfoIcon = styled((props) => <InfoIcon {...props} />)`
  &:hover {
    cursor: pointer;
  }
`;
